export const MOCK_DATA = {
  business_entity: "Private Limited",
  document_categories: [
    {
      id: 1,
      name: "Bank Account Proof",
      uuid: "11e8-748f-297c6048-9081-020aca9875be",
      name_on_frontend: "BANK_PROOF",
      document_types: [
        {
          name: "Cancelled Cheque",
          id: 1,
          uuid: "ca0a-9047-28d705a1-7e97-b530fbec4c41",
        },
        {
          name: "Bank Verification Letter ",
          id: 2,
          uuid: "f912-b658-610ce46f-796b-14a515e41ad7",
        },
      ],
      kyc_document: null,
    },
    {
      id: 2,
      name: "PAN Card of Signing Authority",
      uuid: "11e8-748f-297824ce-9081-020aca9875be",
      name_on_frontend: "PANCARD_SIGNED_AUTHORITY",
      document_types: [
        {
          name: "PAN Card",
          id: 3,
          uuid: "11e8-748f-2946799c-9081-020aca9875be",
        },
      ],
      kyc_document: {
        id: 163,
        document_category_id: 10,
        document_type_id: 10,
        account_id: null,
        remarks: null,
        status: "DOCUMENT_SUBMITTED",
        uuid: "11eb-b85d-cdfacbb8-8e6a-367dda8f1fb9",
        active: true,
        created_at: "2021-05-19T04:50:59.000Z",
        updated_at: "2021-05-19T04:51:24.000Z",
        kyc_document_type: "KYC",
        document_format: "Soft Copy",
        e_stamp_number: null,
        temp_account_id: null,
        error: null,
        record_type: "TempAccount",
        record_id: 11,
        processed_document: {
          id: 149,
          metadata: {
            identified: true,
          },
          filename: "TotalKYC Postman Collection.postman_collection.json",
          byte_size: 79230,
          path: "/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBYkk9IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--c481a758df906e201b9d90e4536d4e6dbc5f9946/TotalKYC%20Postman%20Collection.postman_collection.json",
          kyc_document_uuid: "11eb-b85d-cdfacbb8-8e6a-367dda8f1fb9",
        },
        document_category_name: "Government Issued Certificate",
        document_type_name: "TIN Certificate",
        uploaded_documents: [],
        document_category: {
          id: 10,
          name: "Government Issued Certificate",
          name_on_frontend: "GOVT_ISSUED_CERTIFICATE",
        },
      },
    },
    {
      id: 3,
      name: "PAN Card of Company",
      uuid: "11e8-748f-298078c2-9081-020aca9875be",
      name_on_frontend: "COMPANY_PAN_COPY",
      document_types: [
        {
          name: "PAN Card",
          id: 3,
          uuid: "11e8-748f-2946799c-9081-020aca9875be",
        },
      ],
      kyc_document: null,
    },
    {
      id: 9,
      name: "Address Proof of Signing Authority",
      uuid: "11e8-748f-297a15b8-9081-020aca9875be",
      name_on_frontend: "ADDRESS_PROOF_SIGNED_AUTHORITY",
      document_types: [
        {
          name: "Passport",
          id: 4,
          uuid: "11e8-748f-2948a29e-9081-020aca9875be",
        },
        {
          name: "Aadhar",
          id: 5,
          uuid: "11e8-748f-294a800a-9081-020aca9875be",
        },
        {
          name: "Voter's ID",
          id: 6,
          uuid: "11e8-748f-294c6ef6-9081-020aca9875be",
        },
        {
          name: "Driving Licence",
          id: 7,
          uuid: "11e8-748f-294e7dea-9081-020aca9875be",
        },
        {
          name: "Utilities Bill (electricity, water, landline, gas connection) ",
          id: 8,
          uuid: "11e8-748f-29508112-9081-020aca9875be",
        },
        {
          name: "Address Verification Letter from Bank",
          id: 17,
          uuid: "24d8-a849-14f755a1-d49b-12ca65c5cd7a",
        },
      ],
      kyc_document: null,
    },
    {
      id: 10,
      name: "Government Issued Certificate",
      uuid: "11e8-748f-297e7cb6-9081-020aca9875be",
      name_on_frontend: "GOVT_ISSUED_CERTIFICATE",
      document_types: [
        {
          name: "Certificate of Incorporation",
          id: 31,
          uuid: "11e8-748f-29528674-9081-020aca9875be",
        },
      ],
      kyc_document: null,
    },
    {
      id: 11,
      name: "Authorisation Letter",
      uuid: "11e8-748f-29865bf2-9081-020aca9875be",
      name_on_frontend: "SIGNED_AUTHORISATION_LETTER",
      document_types: [
        {
          name: "Authorisation Letter",
          id: 35,
          uuid: "1acc-c62c-42362b18-e290-64da3a8b1460",
        },
      ],
      kyc_document: null,
    },
    {
      id: 13,
      name: "Service Agreement",
      uuid: "11e8-748f-29762cc8-9081-020aca9875be",
      name_on_frontend: "SERVICE_AGREEMENT",
      document_types: [
        {
          name: "Agreement",
          id: 37,
          uuid: "11e8-748f-293bbf7a-9081-020aca9875be",
        },
      ],
      kyc_document: null,
    },
  ],
};

export const MERCHANT_DOC_STATUS = {
  DOCUMENT_APPROVED: "Docs Approved",
  DOCUMENT_RECEIVED: "Docs Received",
  DOCUMENT_ERROR: "Docs Error",
  PENDING: "Pending",
}

export const INDIVIDUAL_DOC_UPLOAD_STATUS = {
  DOCUMENT_SUBMITTED: "DOCUMENT_SUBMITTED",
  DOCUMENT_REJECTED: "Declined",
  DOCUMENT_VERIFIED: "Approved",
  DOCUMENT_REUPLOADED: "DOCUMENT_REUPLOADED",
  COUNTER_SIGNED: "Counter Signed Received",
  ACCEPTED: "accepted",
  PENDING: "Pending",
};

export const DOCUMENT_CATEGORY_GENERIC_DATA = {
  PANCARD_SIGNED_AUTHORITY: {
    docCategoryLabel: "PAN Card of {{signatory_authority_name}}",
    maxFileSizeLimit: 5,
    fileCount: "single",
  },
  ADDRESS_PROOF_SIGNED_AUTHORITY: {
    docCategoryLabel: "Address Proof of {{signatory_authority_name}}",
    maxFileSizeLimit: 5,
    fileCount: "uploadFrontAndBack",
    docTypes: [
      {
        name: "PASSPORT",
        frontDocName: "Upload first page of Passport",
        backDocName: "Upload last page of Passport",
        optional: [],
      },
      {
        name: "AADHAR",
        frontDocName: "Upload first page of Aadhar Card",
        backDocName: "Upload last page of Aadhar Card",
        optional: [],
      },
    ],
  },
  BANK_PROOF: {
    docCategoryLabel: "Bank Account Proof of {{signatory_authority_name}}",
    maxFileSizeLimit: 5,
    fileCount: "single",
  },
  SERVICE_AGREEMENT: {
    docCategoryLabel: "Service Agreement",
    maxFileSizeLimit: 5,
    fileCount: "multiple",
    docTypes: ["AGR"],
  },
  PATNERSHIP_PAN_CARD: {
    docCategoryLabel: "Partnership PAN Card",
    maxFileSizeLimit: 5,
    fileCount: "single",
  },
  COMPANY_PAN_COPY: {
    docCategoryLabel: "Company PAN Card",
    maxFileSizeLimit: 5,
    fileCount: "single",
  },
  CERTIFICATE_OF_INCORPORATION: {
    docCategoryLabel: "Certificate of Incorporation",
    fileCount: "uploadFrontAndBack",
    docTypes: [
      {
        name: "CERTIFICATE_OF_INCORPORATION",
        frontDocName: "Certificate of Incorporation",
        backDocName: "(Optional) INC 22",
        optional: ["back"],
      },
    ],
    maxFileSizeLimit: 15,
  },
  GOVT_ISSUED_CERTIFICATE: {
    docCategoryLabel: 'Government issued certificate copy',
    maxFileSizeLimit: 15,
  },
  SOCIETY_PAN: {
    docCategoryLabel: 'Society PAN Card',
    fileCount: "single",
    maxFileSizeLimit: 5,
    clevertapEventName: 'Company Pan card'
  },

};

export const DOCUMENT_CHECKLIST = {
  Individual: {
    PANCARD_SIGNED_AUTHORITY: {
      ...DOCUMENT_CATEGORY_GENERIC_DATA.PANCARD_SIGNED_AUTHORITY,
      docCategoryLabel: "PAN Card of {{signatory_authority_name}}",
    },
    ADDRESS_PROOF_SIGNED_AUTHORITY: {
      ...DOCUMENT_CATEGORY_GENERIC_DATA.ADDRESS_PROOF_SIGNED_AUTHORITY,
      docCategoryLabel: "Address Proof of {{signatory_authority_name}}",
    },
    BANK_PROOF: DOCUMENT_CATEGORY_GENERIC_DATA.BANK_PROOF,
    SERVICE_AGREEMENT: DOCUMENT_CATEGORY_GENERIC_DATA.SERVICE_AGREEMENT,
  },
  "Sole Proprietorship": {
    PANCARD_SIGNED_AUTHORITY: {
      ...DOCUMENT_CATEGORY_GENERIC_DATA.PANCARD_SIGNED_AUTHORITY,
      docCategoryLabel: "PAN Card of {{signatory_authority_name}}",
    },
    ADDRESS_PROOF_SIGNED_AUTHORITY: {
      ...DOCUMENT_CATEGORY_GENERIC_DATA.ADDRESS_PROOF_SIGNED_AUTHORITY,
      docCategoryLabel: "Address Proof of {{signatory_authority_name}}",
    },
    BANK_PROOF: DOCUMENT_CATEGORY_GENERIC_DATA.BANK_PROOF,
    GOVT_ISSUED_CERTIFICATE: {
      docCategoryLabel: "Government issued certificate copy",
      fileCount: "multiple",
      docTypes: ["GST_CERTIFICATE", "NOC", "UACC", "TTC", "SERVICE_TAX", "OTHERS"],
      maxFileSizeLimit: 15,
    },
    SERVICE_AGREEMENT: DOCUMENT_CATEGORY_GENERIC_DATA.SERVICE_AGREEMENT,
  },
  Partnership: {
    PANCARD_SIGNED_AUTHORITY: DOCUMENT_CATEGORY_GENERIC_DATA.PANCARD_SIGNED_AUTHORITY,
    ADDRESS_PROOF_SIGNED_AUTHORITY: DOCUMENT_CATEGORY_GENERIC_DATA.ADDRESS_PROOF_SIGNED_AUTHORITY,
    BANK_PROOF: DOCUMENT_CATEGORY_GENERIC_DATA.BANK_PROOF,
    GOVT_ISSUED_CERTIFICATE: {
      docCategoryLabel: "Government issued certificate copy",
      fileCount: "multiple",
      docTypes: ["GST_CERTIFICATE", "NOC", "UACC", "TTC", "SERVICE_TAX", "OTHERS"],
      maxFileSizeLimit: 15,
    },
    PATNERSHIP_PAN_CARD: DOCUMENT_CATEGORY_GENERIC_DATA.PATNERSHIP_PAN_CARD,
    SIGNED_AUTHORISATION_LETTER: {
      docCategoryLabel: "Signed Authorisation Letter",
      fileCount: "single",
    },
    SERVICE_AGREEMENT: DOCUMENT_CATEGORY_GENERIC_DATA.SERVICE_AGREEMENT,
  },
  LLP: {
    PANCARD_SIGNED_AUTHORITY: DOCUMENT_CATEGORY_GENERIC_DATA.PANCARD_SIGNED_AUTHORITY,
    ADDRESS_PROOF_SIGNED_AUTHORITY: DOCUMENT_CATEGORY_GENERIC_DATA.ADDRESS_PROOF_SIGNED_AUTHORITY,
    BANK_PROOF: DOCUMENT_CATEGORY_GENERIC_DATA.BANK_PROOF,
    GOVT_ISSUED_CERTIFICATE: DOCUMENT_CATEGORY_GENERIC_DATA.CERTIFICATE_OF_INCORPORATION,
    LLP_PAN_CARD: {
      docCategoryLabel: "LLP PAN Card",
      maxFileSizeLimit: 5,
      fileCount: "single",
    },
    SIGNED_AUTHORISATION_LETTER: {
      docCategoryLabel: "Signed Authorisation Letter",
      fileCount: "single",
    },
    SERVICE_AGREEMENT: DOCUMENT_CATEGORY_GENERIC_DATA.SERVICE_AGREEMENT,
  },
  "Private Limited": {
    PANCARD_SIGNED_AUTHORITY: DOCUMENT_CATEGORY_GENERIC_DATA.PANCARD_SIGNED_AUTHORITY,
    ADDRESS_PROOF_SIGNED_AUTHORITY: DOCUMENT_CATEGORY_GENERIC_DATA.ADDRESS_PROOF_SIGNED_AUTHORITY,
    BANK_PROOF: DOCUMENT_CATEGORY_GENERIC_DATA.BANK_PROOF,
    GOVT_ISSUED_CERTIFICATE: DOCUMENT_CATEGORY_GENERIC_DATA.CERTIFICATE_OF_INCORPORATION,
    COMPANY_PAN_COPY: DOCUMENT_CATEGORY_GENERIC_DATA.COMPANY_PAN_COPY,
    SIGNED_AUTHORISATION_LETTER: {
      docCategoryLabel: "Signed Authorisation Letter",
      fileCount: "single",
    },
    SERVICE_AGREEMENT: DOCUMENT_CATEGORY_GENERIC_DATA.SERVICE_AGREEMENT,
  },
  "Public Limited": {
    PANCARD_SIGNED_AUTHORITY: DOCUMENT_CATEGORY_GENERIC_DATA.PANCARD_SIGNED_AUTHORITY,
    ADDRESS_PROOF_SIGNED_AUTHORITY: DOCUMENT_CATEGORY_GENERIC_DATA.ADDRESS_PROOF_SIGNED_AUTHORITY,
    BANK_PROOF: DOCUMENT_CATEGORY_GENERIC_DATA.BANK_PROOF,
    GOVT_ISSUED_CERTIFICATE: DOCUMENT_CATEGORY_GENERIC_DATA.CERTIFICATE_OF_INCORPORATION,
    COMPANY_PAN_COPY: DOCUMENT_CATEGORY_GENERIC_DATA.COMPANY_PAN_COPY,
    SIGNED_AUTHORISATION_LETTER: {
      docCategoryLabel: "Signed Authorisation Letter",
      fileCount: "single",
    },
    SERVICE_AGREEMENT: DOCUMENT_CATEGORY_GENERIC_DATA.SERVICE_AGREEMENT,
  },
  Trust: {
    PANCARD_SIGNED_AUTHORITY: DOCUMENT_CATEGORY_GENERIC_DATA.PANCARD_SIGNED_AUTHORITY,
    ADDRESS_PROOF_SIGNED_AUTHORITY: DOCUMENT_CATEGORY_GENERIC_DATA.ADDRESS_PROOF_SIGNED_AUTHORITY,
    BANK_PROOF: DOCUMENT_CATEGORY_GENERIC_DATA.BANK_PROOF,
    GOVT_ISSUED_CERTIFICATE: {
      docCategoryLabel: "Government issued certificate copy",
      fileCount: "multiple",
      docTypes: ["CR", "C80G", "TDVR"],
      maxFileSizeLimit: 15,
    },
    TRUST_PAN: {
      docCategoryLabel: "Trust PAN Card",
      fileCount: "single",
      maxFileSizeLimit: 5,
    },
    SIGNED_AUTHORISATION_LETTER: {
      docCategoryLabel: "Signed Authorisation Letter",
      fileCount: "single",
    },
    SERVICE_AGREEMENT: DOCUMENT_CATEGORY_GENERIC_DATA.SERVICE_AGREEMENT,
  },
  Society: {
    PANCARD_SIGNED_AUTHORITY: DOCUMENT_CATEGORY_GENERIC_DATA.PANCARD_SIGNED_AUTHORITY,
    ADDRESS_PROOF_SIGNED_AUTHORITY: DOCUMENT_CATEGORY_GENERIC_DATA.ADDRESS_PROOF_SIGNED_AUTHORITY,
    BANK_PROOF: DOCUMENT_CATEGORY_GENERIC_DATA.BANK_PROOF,
    GOVT_ISSUED_CERTIFICATE: {
      docCategoryLabel: "Government issued certificate copy",
      fileCount: "multiple",
      docTypes: ["CR", "C80G", "SDVR"],
      maxFileSizeLimit: 15,
    },
    SOCIETY_PAN: {
      docCategoryLabel: "Society PAN Card",
      maxFileSizeLimit: 5,
      fileCount: "single",
    },
    SIGNED_AUTHORISATION_LETTER: {
      docCategoryLabel: "Signed Authorisation Letter",
      fileCount: "single",
    },
    SERVICE_AGREEMENT: DOCUMENT_CATEGORY_GENERIC_DATA.SERVICE_AGREEMENT,
  },
  'Government': {
    PANCARD_SIGNED_AUTHORITY: DOCUMENT_CATEGORY_GENERIC_DATA.PANCARD_SIGNED_AUTHORITY,
    ADDRESS_PROOF_SIGNED_AUTHORITY: DOCUMENT_CATEGORY_GENERIC_DATA.ADDRESS_PROOF_SIGNED_AUTHORITY,
    BANK_PROOF: DOCUMENT_CATEGORY_GENERIC_DATA.BANK_PROOF,
    GOVT_ISSUED_CERTIFICATE: DOCUMENT_CATEGORY_GENERIC_DATA.CERTIFICATE_OF_INCORPORATION,
  },
  NGO: {
    PANCARD_SIGNED_AUTHORITY: DOCUMENT_CATEGORY_GENERIC_DATA.PANCARD_SIGNED_AUTHORITY,
    ADDRESS_PROOF_SIGNED_AUTHORITY: DOCUMENT_CATEGORY_GENERIC_DATA.ADDRESS_PROOF_SIGNED_AUTHORITY,
    BANK_PROOF: DOCUMENT_CATEGORY_GENERIC_DATA.BANK_PROOF,
    SOCIETY_PAN: DOCUMENT_CATEGORY_GENERIC_DATA.SOCIETY_PAN,
    GOVT_ISSUED_CERTIFICATE: {
      ...DOCUMENT_CATEGORY_GENERIC_DATA.GOVT_ISSUED_CERTIFICATE,
      fileCount: "multiple",
      docTypes: ["C80G"],
      maxFileSizeLimit: 15,
    },
    SERVICE_AGREEMENT: DOCUMENT_CATEGORY_GENERIC_DATA.SERVICE_AGREEMENT
  },
  'One Person Company': {
    PANCARD_SIGNED_AUTHORITY: DOCUMENT_CATEGORY_GENERIC_DATA.PANCARD_SIGNED_AUTHORITY,
    ADDRESS_PROOF_SIGNED_AUTHORITY: DOCUMENT_CATEGORY_GENERIC_DATA.ADDRESS_PROOF_SIGNED_AUTHORITY,
    BANK_PROOF: DOCUMENT_CATEGORY_GENERIC_DATA.BANK_PROOF,
    COMPANY_PAN_COPY: DOCUMENT_CATEGORY_GENERIC_DATA.COMPANY_PAN_COPY,
    GOVT_ISSUED_CERTIFICATE: DOCUMENT_CATEGORY_GENERIC_DATA.CERTIFICATE_OF_INCORPORATION,
    SERVICE_AGREEMENT: DOCUMENT_CATEGORY_GENERIC_DATA.SERVICE_AGREEMENT,
  }
};

export const DOCUMENT_SUBCATEGORIES = {
  PASSPORT: {
    docTypeLabel: "Passport",
    value: "4",
  },
  AADHAR: {
    docTypeLabel: "Aadhar Card",
    value: "5",
  },
  VOTER: {
    docTypeLabel: "Voter Card",
    value: "6",
  },
  DL: {
    docTypeLabel: "Driving License",
    value: "7",
  },
  BMTB: {
    docTypeLabel: "Landline telephone Bill",
    value: "8",
  },
  AVFB: {
    docTypeLabel: "Address Verification Letter from Bank",
    value: "6",
  },
  CC: {
    docTypeLabel: "Cancelled Cheque",
    value: "1",
  },
  BC: {
    docTypeLabel: "Bank Verification letter",
    value: "2",
  },
  TTC: {
    docTypeLabel: "TIN/TAN Certificate",
    value: "9",
  },
  LOR: {
    docTypeLabel: "Letter of Registration",
    value: "10",
  },
  IEP: {
    docTypeLabel: "Import/Export License",
    value: "11",
  },
  LL: {
    docTypeLabel: "Labour License",
    value: "12",
  },
  CEC: {
    docTypeLabel: "Central Excise Certificate",
    value: "13",
  },
  MCC: {
    docTypeLabel: "Municipal Corporation Certificate",
    value: "14",
  },
  UACC: {
    docTypeLabel: "Udyog Aadhar Card Certificate",
    value: "15",
  },
  NOC: {
    docTypeLabel: "NOC by Gram Panchayat",
    value: "16",
  },
  COR: {
    docTypeLabel: "Valid Business License or Certificate of Registration",
    value: "17",
  },
  LIRA: {
    docTypeLabel: "License (eg. Certificate of Practice) issued by Registering Authorities", // iCAI, ICWAI, ICSI, IRDA etc.
    value: "18",
  },
  PDVR: {
    docTypeLabel: "Partnership Deed verified by the registrar",
    value: "19",
  },
  CORIR: {
    docTypeLabel: "Certificate of Registration/incorporation issued by registrar of firm",
    value: "20",
  },
  CR: {
    docTypeLabel: "Certificate of Registration",
    value: "22",
  },
  C80G: {
    docTypeLabel: "80G and 12A Certificate (mandatory if trust/society is taking donation)",
    value: "23",
  },
  TDVR: {
    docTypeLabel: "Trust Deed verified by the registrar",
    value: "24",
  },
  SDVR: {
    docTypeLabel: "Society Deed verified by the registrar",
    value: "26",
  },
  OTHERS: {
    docTypeLabel: "Others",
    value: "27",
    subLabel: `(Vat / Dvat-Import/ Export License / Labour License / Central Excise Certificate
                / Municipal Corporation Certificate / Certificate of Business Registration /
                License issued by Registering Authorities like ICAI, ICWAI, ICSI, IRDA) /
                Partnership Deed verified by the registrar`,
  },
  GST_CERTIFICATE: {
    docTypeLabel: "GST Registration Certificate",
    value: "28",
  },
  SERVICE_TAX: {
    docTypeLabel: "Service Tax",
    value: "29",
  },
  CERTIFICATE_OF_INCORPORATION: {
    docTypeLabel: "Certificate of Incorporation",
    modalDescription: "Upload INC 22 with payment challan if your address on certificate of incorporation is outdated",
  },
};

export const WEBSITE_DOCUMENT_CHECKLIST = {
  CERTIFICATE_80G_12A: { label: '80G or 12A Certificate' },
  NO_TAX_EXEMPTION: { label: 'Undertaking on Letterhead for no tax exemption claim' },
  AFFILIATION_CERTIFICATE: { label: 'Affiliation certificate' },
  BIS_CERTIFICATE: { label: 'BIS Certificate' },
  CHEMICALS_FERTILIZERS_CERTIFICATE: { label: 'Certificate from Ministry of Chemicals and Fertilizers' },
  DAS_LICENSE: { label: 'DAS license' },
  DGCA_LICENSE: { label: 'DGCA license' },
  FSSAI_CERTIFICATE: { label: 'FSSAI certificate' },
  GEMOLOGICAL_CERTIFICATE: { label: 'Gemological institute certificate' },
  FRANCHISEE_AGREEMENT: { label: 'Franchisee Agreement with Bank' },
  TOURISM_MINISTRY_APPROVAL: { label: 'Approval from Indian Ministry of Tourism' },
  IATA_CERTIFICATE: { label: 'IATA Certificate' },
  WEB_HOSTING_INVOICE: { label: 'Web Hosting Invoice' },
  PROCUREMENT_INVOICE: { label: 'Procurement Invoice' },
  IRDA_CERTIFICATE: { label: 'IRDA certificate' },
  AUDITED_FINANCIALS_2_YEARS: { label: 'Last 2 years Audited Financials' },
  BANK_STATEMENT_6_MONTHS: { label: 'Last 6 Months Bank Statement' },
  SHIPPING_LICENSE: { label: 'License from Directorate General of shipping' },
  LOGISTIC_TRANSPORT_LICENSE: { label: 'Logistic Transport License' },
  NBFC_CERTIFICATE: { label: 'NBFC Certificate' },
  NISM_MFD: { label: 'NISM MFD' },
  VENURE_BOOKING_RECEIPT: { label: 'Venue Booking Receipt' },
  PCI_DSS_CERTIFICATE: { label: 'PCI DSS certificate' },
  PEST_CONTROL_LICENSE: { label: 'Pest control business license' },
  POLICE_VERIFICATION_CERTIFICATE: { label: 'Police Verification Certificate' },
  RADIO_LICENSE: { label: 'Radio License' },
  MONEY_CHANGER_LICENSE: { label: 'Money Changer License' },
  RBI_LICENSE: { label: 'RBI License' },
  RBI_PPI_LICENSE: { label: 'RBI PPI license' },
  RERA_CERTIFICATE: { label: 'RERA Certificate' },
  SAMPLE_PROOF_DELIVERY: { label: 'Sample Proof of Delivery' },
  SEBI_CERTIFICATE: { label: 'SEBI Certificate' },
  SEBI_INVESTMENT_ADVISOR_CERTIFICATE: { label: 'SEBI certificate as Investment Advisor' },
  TIE_UP_AGREEMENT: { label: 'Tie-up Agreement with your Partners' },
  ISP_LICENSE: { label: 'ISP License' },
  NSDL_CERTIFICATE: { label: 'NSDL Certificate' },
  ACCREDITION_CERTIFICATE: { label: 'Accredition Certificate' },
  PROPERTY_OWNERSHIP_DOCUMENT: { label: 'Document validating Ownership of Property' },
  CRUISE_OWNERS_AGREEMENT: { label: 'Tie-up Agreement with Cruise Owners' },
  DIAGNOSTIC_CENTRES_AGREEMENT: { label: 'Tie-up Agreement with Car Owners' },
  CAR_OWNERS_AGREEMENT: { label: 'Tie-up Agreement with Diagnostic Centers' },
  LOGISTIC_PARTNERS_AGREEMENT: { label: 'Tie-up Agreement with Logistic Partners' },
  NBFC_AGREEMENT: { label: 'Tie-up Agreement with NBFC' },
  UNIFORM_ORGANISATIONS_AGREEMENT: { label: 'Tie-up Agreement with Uniform Organisations' },
  RESTAURANTS_AGREEMENT: { label: 'Tie-up Agreement with Restaurants' },
  SCHOOLS_COLLEGES_AGREEMENT: { label: 'Tie-up Agreement with Schools/Colleges' },
  SERVICE_PROVIDERS_AGREEMENT: { label: 'Tie-up Agreement with Service Providers' },
  SHOPS_DEALERS_AGREEMENT: { label: 'Tie-up Agreement with Shops/Dealers' },
  SOCIETIES_AGREEMENT: { label: 'Tie-up Agreement with Societies' },
  TUTORS_AGREEMENT: { label: 'Tie-up Agreement with Tutors' },
  VENDORS_SERVICE_PROVIDERS_AGREEMENT: { label: 'Tie-up Agreement with vendors/service providers' },
  AUTHORISATION_DOCUMENT: { label: 'Authorisation Document for carrying out this business' },
  JUDGES_CONFIRMATION_LETTER: { label: 'Confirmation email/letter from the judges' },
  IE_LICENSE: { label: 'IE license' },
  FILMS_EXHIBITION_CERTIFICATE: { label: 'Approved Films Exhibition Certificate' },
  MANUFACTURING_LICENSE: { label: 'Manufacturing License' },
  CSP_DOCUMENT: { label: 'Grahak Seva Kendra or CSP Document' },
  COURSE_COMPLETION_CERTIFICATE: { label: 'Course Completion Sample Certificate' },
  DIRECT_SELLING_LICENSE: { label: 'Direct Selling License' },
  AYUSH_CERTIFICATE: { label: 'AYUSH Certificate' },
  GMP_CERTIFICATE: { label: 'GMP Certificate' },
  HOMEOPATHIC_SELLING_LICENSE: { label: 'Homeopathic Selling Drugs License' }
};

